import { forwardRef } from 'react';
import {
  Stack as MuiStack,
  type StackProps as MuiStackProps,
} from '@mui/material';

type Align = React.CSSProperties['alignItems'];
type Justify = React.CSSProperties['justifyContent'];

export interface StackProps extends MuiStackProps {
  alignItems?: Align | Record<string, Align>;
  justifyContent?: Justify | Record<string, Justify>;
}

/**
 * MUI v9 dropped `alignItems`/`justifyContent` as direct <Stack> props. This
 * thin wrapper restores that ergonomics by folding them into `sx`.
 */
export const Stack = forwardRef<HTMLDivElement, StackProps>(function Stack(
  { alignItems, justifyContent, sx, ...rest },
  ref,
) {
  return (
    <MuiStack ref={ref} sx={{ alignItems, justifyContent, ...sx }} {...rest} />
  );
});
